var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M17.0036 15.3264C16.8162 15.5126 16.5628 15.6172 16.2986 15.6172C16.0344 15.6172 15.781 15.5126 15.5936 15.3264L12.0036 11.7864L8.46361 15.3264C8.27625 15.5126 8.0228 15.6172 7.75861 15.6172C7.49442 15.6172 7.24097 15.5126 7.05361 15.3264C6.95988 15.2334 6.88549 15.1228 6.83472 15.001C6.78395 14.8791 6.75781 14.7484 6.75781 14.6164C6.75781 14.4844 6.78395 14.3537 6.83472 14.2318C6.88549 14.11 6.95988 13.9994 7.05361 13.9064L11.2936 9.6664C11.3866 9.57267 11.4972 9.49827 11.619 9.4475C11.7409 9.39674 11.8716 9.3706 12.0036 9.3706C12.1356 9.3706 12.2663 9.39674 12.3882 9.4475C12.51 9.49827 12.6206 9.57267 12.7136 9.6664L17.0036 13.9064C17.0973 13.9994 17.1717 14.11 17.2225 14.2318C17.2733 14.3537 17.2994 14.4844 17.2994 14.6164C17.2994 14.7484 17.2733 14.8791 17.2225 15.001C17.1717 15.1228 17.0973 15.2334 17.0036 15.3264Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownIcon);
export default __webpack_public_path__ + "static/media/chevron_down-icon.b494cdd24ef31736ed8c77f5d1bbed15.svg";
export { ForwardRef as ReactComponent };